import { AfterViewInit, Component, EventEmitter, Inject, Output } from '@angular/core';

import {AgenceService } from '../../../structure/agence/services/agence.service'

import { AgenceTLR } from '../../../structure/agence/entities/agence-tlr.entity';
import { PerimetreFilters } from '../entities/perimetre-filters.entity';
import { ParcService } from '../../../structure/parc/services/parc.service';
import { ParcTLR } from '../../../structure/parc/entities/parc-tlr.entity';

@Component({
	selector: 'consultation-perimetre-filters',
	templateUrl: 'consultation-perimetre-filters.html',
	styleUrls: ['consultation-perimetre-filters.css']
})
export class ConsultationPerimetreFiltersComponent implements AfterViewInit {
	
	selectedAgences!: AgenceTLR[];
	agences: AgenceTLR[] = [];

	agenceLabelGetter = (agence: AgenceTLR) => agence.nom;
	
	filters: PerimetreFilters = new PerimetreFilters();
	
	preselectAgenceByDefault = (agence: AgenceTLR) => true;
	
	@Output() filterRequest = new EventEmitter<PerimetreFilters>();

	constructor(@Inject(AgenceService) private agenceService: AgenceService, @Inject(ParcService) private parcService: ParcService){
		
		agenceService.getAgenceTLRList().subscribe(
			(agences) => {
				this.agences = [];
				agences.forEach( $ => this.agences.push($) );
			}
		);
	}
	
	ngAfterViewInit() {
		this.applyFilters();
	}

	applyFilters() {
		this.filterRequest.emit(this.filters);
	}
	
	onParcChange(selectedParcId: number | null) {
		console.log('on a choisit le parc id: ', selectedParcId);
		// recupere code from id
		if (selectedParcId != null) {
			this.parcService.getParcTLRById(selectedParcId).subscribe(
				(parc: ParcTLR) => {
					this.filters.codeParc = parc.code; // recupérer le code parc associé à ce code
					this.filterRequest.emit(this.filters); // emettre un signal pour filtrer le tableau de résultat
				}
			);
		} else {
			this.filters.codeParc = ''; 
		    this.filterRequest.emit(this.filters); 
		}
	}
	
	onAgenceChange(selection: [AgenceTLR[], boolean]) {
		this.selectedAgences = selection[0];
		this.filters.selectedAgenceIds = this.selectedAgences.map($ => $.id);
		this.filterRequest.emit(this.filters); // emettre un signal pour filtrer le tableau de résultat		
	}
}